
































import Vue from "vue";
import Navigation from "@/components/organisms/Navigation.vue";
import SentryUtil from "@/utils/sentryUtil";
import TopBar from "@/components/organisms/TopBar.vue";

export default Vue.extend({
  name: "SingleColumn",
  props: {
    showNavigation: {
      type: Boolean,
      default: true,
    },
    showTopBar: {
      type: Boolean,
      default: true,
    },
  },
  components: { Navigation, TopBar },
  mounted() {
    SentryUtil.setUser();
  },
  computed: {},
});
